<template>
  <div class="app-products-status-change">
    <v-header />
    <status-changes />
  </div>
</template>

<script>
import VHeader from "@/components/header";
import StatusChanges from "@/components/user/products/ProductStatusChanger.vue";
import User from "@/models/User.js";

// @ is an alias to /src
export default {
  name: "app-products-status-change",
  data() {
    return {
      user: new User(this.$session.get("user")),
    };
  },
  created() {
    if (this.user.company_id == 9) {
      this.$session.destroy();
      this.$router.push("/login").catch(() => {});
    }
  },
  components: {
    VHeader,
    StatusChanges,
  },
};
</script>
